import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setUser} from "../../services/apiCalls";
import {getUserAction} from "../../services/userService";
import ButtonComponent from "../button/buttonComponent";
import InputErrorTextComponent from "../input/inputErrorTextComponent";

function ChangeUsernameFormComponent() {
    const dispatch = useDispatch();
    const user = useSelector(state => state.userReducer.user);
    
    const [username, setUsername] = useState(user?.name || "");
    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorText, setErrorText] = useState(null);
    const [successText, setSuccessText] = useState(null);

    const handleSave = async () => {
        if (!username.trim()) {
            setErrorText("Kullanıcı adı boş olamaz.");
            return;
        }

        setIsLoading(true);
        setErrorText(null);
        setSuccessText(null);

        try {
            const updatedUser = {
                ...user,
                name: username.trim()
            };
            
            await setUser(updatedUser);
            dispatch(getUserAction(updatedUser));
            
            setSuccessText("Kullanıcı adı başarıyla güncellendi!");
            setIsEditing(false);
            
            // Clear success message after 3 seconds
            setTimeout(() => setSuccessText(null), 3000);
        } catch (error) {
            console.error("Error updating username:", error);
            setErrorText("Kullanıcı adı güncellenirken hata oluştu. Lütfen tekrar deneyiniz.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleCancel = () => {
        setUsername(user?.name || "");
        setIsEditing(false);
        setErrorText(null);
    };

    return (
        <div style={{marginBottom: '20px', padding: '15px', backgroundColor: '#f9f9f9', borderRadius: '8px', border: '1px solid #e0e0e0'}}>
            <h3 style={{margin: '0 0 15px 0', color: '#333', fontSize: 'clamp(15px, 4vw, 16px)', fontWeight: '600'}}>
                Kullanıcı Adı
            </h3>
            
            {!isEditing ? (
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px', flexWrap: 'wrap'}}>
                    <p style={{margin: '0', fontSize: 'clamp(14px, 3.5vw, 16px)', color: '#555', fontWeight: '500', flex: '1'}}>
                        {user?.name || "Henüz belirtilmemiş"}
                    </p>
                    <ButtonComponent 
                        text="Değiştir" 
                        onClick={() => setIsEditing(true)}
                        isDisabled={false}
                    />
                </div>
            ) : (
                <div>
                    <div style={{marginBottom: '15px'}}>
                        <label style={{display: 'block', marginBottom: '5px', fontSize: 'clamp(13px, 3.5vw, 14px)', color: '#333', fontWeight: '500'}}>
                            Yeni Kullanıcı Adı
                        </label>
                        <input 
                            type="text" 
                            value={username} 
                            onChange={(e) => setUsername(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" && !isLoading) handleSave();
                                if (e.key === "Escape") handleCancel();
                            }}
                            disabled={isLoading}
                            style={{
                                width: '100%',
                                padding: '12px',
                                fontSize: 'clamp(13px, 3.5vw, 14px)',
                                border: '1px solid #ddd',
                                borderRadius: '5px',
                                boxSizing: 'border-box',
                                fontFamily: 'inherit',
                                touchAction: 'manipulation'
                            }}
                        />
                    </div>
                    
                    <div style={{display: 'flex', gap: '10px', marginBottom: '15px', flexWrap: 'wrap'}}>
                        <ButtonComponent 
                            text="Kaydet" 
                            onClick={handleSave}
                            isDisabled={isLoading}
                        />
                        <ButtonComponent 
                            text="İptal" 
                            onClick={handleCancel}
                            isDisabled={isLoading}
                        />
                    </div>
                    
                    {errorText && <div style={{color: '#d32f2f', fontSize: 'clamp(12px, 3vw, 13px)', marginBottom: '10px'}}>{errorText}</div>}
                    {successText && <div style={{color: '#388e3c', fontSize: 'clamp(12px, 3vw, 13px)', marginBottom: '10px'}}>{successText}</div>}
                </div>
            )}
        </div>
    );
}

export default ChangeUsernameFormComponent;

